
import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { Radar, RadarChart, PolarGrid, Legend, PolarAngleAxis, Tooltip, PolarRadiusAxis } from 'recharts';

// Custom tick renderer for multi-line axis labels
function CustomAngleTick(props) {
    const { payload, x, y, textAnchor, stroke, pointCount } = props;
    let label = payload.value;
    let index = payload.index; // axis index
    let extraOffset = 0;

    // Add extra spacing for the bottom label on 6-point radar charts.
    // This improves readability for value charts (e.g., Integrity / Honor).
    if (pointCount === 6 && index === 3) {
        extraOffset = 10;
    }

    // Split the third axis label over 2 lines (language-agnostic), keeping '/' on line 1.
    if (index === 2 && typeof label === 'string' && label.includes('/')) {
        const slashIndex = label.indexOf('/');
        label = [
            `${label.slice(0, slashIndex).trimEnd()} /`,
            label.slice(slashIndex + 1).trimStart(),
        ];
    } else {
        label = [label];
    }

    return (
        <text
            x={x}
            y={y}
            textAnchor={textAnchor}
            stroke={stroke}
            fontSize={15}
            fill="#808080"
        >
            {label.map((line, i) => (
                <tspan x={x} dy={i === 0 ? extraOffset : 18} key={i}>
                    {line}
                </tspan>
            ))}
        </text>
    );
}

export default function RadarGraph({ data }) {
    const { locale } = useContext(LanguageContext);
    const langInf = { "fr": "tiers inférieur", "en": "lower third", "de": "unteres Drittel", "it": "terzo inferiore", "es": "tercio inferior" }
    const langMid = { "fr": "tiers moyen", "en": "middle third", "de": "mittleres Drittel", "it": "terzo medio", "es": "tercio medio" }
    const langUp = { "fr": "tiers supérieur", "en": "upper third", "de": "oberes Drittel", "it": "terzo superiore", "es": "tercio superior" }
    const langCandidate = { "fr": "candidat(e)", "en": "candidate", "de": "Kandidat(in)", "it": "candidato/a", "es": "candidato/a" }
    
    data = data.map(({de,en,fr,it,es,fullMark,lowerThird,middleThird,upperThird,user}) => {
        return {
            de: de,
            en: en,
            fr: fr,
            it: it,
            es: es,
            fullmark: fullMark,
            lowerthird: lowerThird,
            middlethird: middleThird,
            upperthird: upperThird,
            user: user
            }
      });

    let tick = { fontSize: 15 };
    let strokeWidth = 3;
    let size = 600;
    let maxValue = 7;
    let minValue = 0;
     //console.log("RadarGraph data:", data, data?.length);
if (data?.length === 3) {
    /*console.log("RadarGraph data:", data, data?.length);*/
    size = 760;
    strokeWidth = 3;
    tick = false; // Hide ticks if these are action orientation points
    // Update the first object's fullmark property
    maxValue = Math.max(
        ...data.map(d => Math.max(d.user, d.upperthird))
    );

    maxValue = maxValue + 0.1; // Ensure maxValue is greater than the highest user or upperthird value
    
    minValue = Math.min(
        ...data.map(d => Math.min(d.user, d.lowerthird))
    );

    minValue = Math.max(0, minValue - 0.3).toFixed(2);
    // Set all fullmark values to this max
    data = data.map(d => ({ ...d, fullmark: maxValue }));
    /*console.log("AFTER RadarGraph data:", data, data?.length);*/

    return (
      <div style={{ marginTop: '-45px' }}>
            <RadarChart
                width={size + 30}
                height={size}
                data={data}
                margin={{ top: 0, right: 30, bottom: 0, left: 30 }}
            >
                <PolarGrid />
                                <PolarAngleAxis
                                    dataKey={locale}
                                    tick={<CustomAngleTick pointCount={data.length} />}
                                />
                <PolarRadiusAxis domain={[minValue, maxValue]} />
                <Radar
                name={langInf[locale]}
                dataKey="lowerthird"
                stroke="var(--ppe-green)"
                fill="var(--ppe-green-80)"
                fillOpacity={0.4}
                />
                <Radar
                name={langMid[locale]}
                dataKey="middlethird"
                stroke="var(--ppe-green-80)"
                fill="var(--ppe-green-40)"
                fillOpacity={0.5}
                />
                <Radar
                name={langUp[locale]}
                dataKey="upperthird"
                stroke="var(--ppe-green-60)"
                fill="var(--ppe-green-10)"
                fillOpacity={0.8}
                />
                <Radar
                name={langCandidate[locale]}
                dataKey="user"
                strokeWidth={strokeWidth}
                stroke="var(--ppe-orange)"
                fill="var(--ppe-orange-20)"
                />
                <Tooltip />
                <Legend />
            </RadarChart>
            </div>
            );
}
console.log("RadarGraph data:", data, data?.length);

      return (
        <RadarChart width={size + 100} height={size} data={data}>
            <PolarGrid />
                <PolarAngleAxis
                    dataKey={locale}
                    tick={<CustomAngleTick pointCount={data.length} />}
                />
            <PolarRadiusAxis domain={[minValue, maxValue]} />
                <Radar name={langInf[locale]} dataKey="lowerthird" stroke="var(--ppe-green)" fill="var(--ppe-green-80)" fillOpacity={0.4} />
                <Radar name={langMid[locale]} dataKey="middlethird" stroke="var(--ppe-green-80)" fill="var(--ppe-green-40)" fillOpacity={0.5} />
                <Radar name={langUp[locale]} dataKey="upperthird" stroke="var(--ppe-green-60)" fill="var(--ppe-green-10)" fillOpacity={0.8} />
                <Radar name={langCandidate[locale]} dataKey="user" strokeWidth={strokeWidth} stroke="var(--ppe-orange)" fill="var(--ppe-orange)" fillOpacity={0.2} />
            {<Tooltip />}
            <Legend />
        </RadarChart>
    )
}
